module.exports = __webpack_public_path__ + "static/media/logo.b670081f.svg";